import BINGO from "./../seedsongs/Kid Songs - B-I-N-G-O.pro";
import GREEN_GRASS_GREW_ALL_AROUND from "./../seedsongs/Kid Songs - Green Grass Grew All Around.pro";
import TWINKLE_TWINKLE from "./../seedsongs/Kid Songs - Twinkle, Twinkle, Little Star.pro";
import AMAZING_GRACE from "./../seedsongs/Spiritual - Amazing Grace.pro";
import DOWN_BY_THE_RIVERSIDE from "./../seedsongs/Spiritual - Down By the Riverside.pro";
import JINGLE_BELLS from "./../seedsongs/Spiritual - Jingle Bells.pro";
import O_CHRISTMAS_TREE from "./../seedsongs/Spiritual - O Christmas Tree.pro";
import SWING_LOW_SWEET_CHARIOT from "./../seedsongs/Spiritual - Swing Low, Sweet Chariot.pro";
import HOME_ON_THE_RANGE from "./../seedsongs/Traditional - Home On The Range.pro";
import OH_MY_DARLING_CLEMENTINE from "./../seedsongs/Traditional - Oh My Darling Clementine.pro";
import SOLIDARITY_FOREVER from "./../seedsongs/Traditional - Solidarity Forever.pro";
import TAKE_ME_OUT_TO_THE_BALL_GAME from "./../seedsongs/Traditional - Take Me Out to the Ball Game.pro";
import chordProToSong from "./chordProToSong";
import type { SongIdMap, Songs } from "./types";

//import redis from "@vercel/redis";

export const demoSongsChordPro = [
  BINGO,
  JINGLE_BELLS,
  SOLIDARITY_FOREVER,
  DOWN_BY_THE_RIVERSIDE,
  OH_MY_DARLING_CLEMENTINE,
  GREEN_GRASS_GREW_ALL_AROUND,
  TWINKLE_TWINKLE,
  TAKE_ME_OUT_TO_THE_BALL_GAME,
  O_CHRISTMAS_TREE,
  SWING_LOW_SWEET_CHARIOT,
  AMAZING_GRACE,
  HOME_ON_THE_RANGE,
];

// export async function getDemoSongsCached() {
//   console.time("demoSongs redis.get");
//   const songsCached = (await redis.get("demoSongs")) as string;
//   console.timeEnd("demoSongs redis.get");
//   if (songsCached) {
//     return JSON.parse(songsCached);
//   }
//   const demoSongs = getDemoSongs_();
//   console.time("demoSongs redis.set");
//   await redis.set("demoSongs", JSON.stringify(demoSongs));
//   console.timeEnd("demoSongs redis.set");
//   return demoSongs;
// }

const getDemoSongs_ = () => {
  const songs: Songs = {};
  const songIdMap: SongIdMap = {};
  //console.time("demoSongs chordProToSong");
  demoSongsChordPro.forEach((chordPro, i) => {
    const id = `${i}`;
    const song = chordProToSong({ chordPro, id, userId: "" });
    //console.debug("chordProToSong", song.title, { song });
    songs[id] = song;
    const ts = Date.now();
    songIdMap[id] = {
      added_timestamp: ts,
      updated_timestamp: ts,
      deleted_timestamp: 0,
      view_count: 0,
      last_viewed_timestamp: 0,
    };
  });
  //console.timeEnd("demoSongs chordProToSong");

  return {
    songIdMap,
    songs,
  };
};

const demoSongs = getDemoSongs_();
export default demoSongs;
